import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FormComponent, RowComponent, FieldComponent } from '@src/app/components';

import { FormType } from './types';

@Component({
  selector: 'filter-mapping-form',
  standalone: true,
  imports: [ReactiveFormsModule, InputTextModule, FormComponent, RowComponent, FieldComponent],
  templateUrl: './mapping-form.component.html',
  styleUrl: './mapping-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MappingFormComponent {
  @Input() form!: FormGroup<FormType>;
  @Input() loading = false;
}
